import React, { useContext, useMemo } from "react";
import PredictionContext from "../../context/predictionFlow/predictionContext";
import { useNavigate } from "react-router-dom";

const steps = [
  "Start",
  "Select Country",
  "Select Election Type",
  "Select Prediction Type",
  "Create Prediction",
];

const PredictionStepper = () => {
  const { prediction, setPrediction, resetPrediction } =
    useContext(PredictionContext);
  const navigate = useNavigate();

  const currentStep = useMemo(() => {
    // console.log("prediction", prediction);

    if (
      prediction.newPrediction &&
      prediction.selectCountry &&
      prediction.electionTypeData?.id &&
      prediction.showNext &&
      prediction?.predictionTitle &&
      prediction?.predictionTitle !== null
    ) {
      return 4;
    }

    if (
      prediction.newPrediction &&
      prediction.selectCountry &&
      prediction.electionTypeData?.id &&
      prediction.showNext
    ) {
      return 3;
    }

    if (
      prediction.newPrediction &&
      prediction.selectCountry &&
      prediction.electionTypeData?.id &&
      prediction.electionTypeData?.id !== null
    ) {
      return 2;
    }

    if (prediction.newPrediction && prediction.selectCountry) {
      return 1;
    }

    if (prediction.newPrediction) {
      return 0;
    }

    return 0;
  }, [prediction]);

  const onStepClick = (stepIndex) => {
    if (stepIndex > currentStep) return;

    switch (stepIndex) {
      case 0:
        resetPrediction();
        navigate("/prediction");
        break;
      case 1:
        setPrediction((prev) => ({
          ...prev,
          newPrediction: true,
          selectCountry: null,
          electionTypeData: {},
          predictionType: null,
          showNext: false,
        }));
        navigate("/prediction");
        break;
      case 2:
        if (prediction.selectCountry) {
          setPrediction((prev) => ({
            ...prev,
            electionTypeData: {},
            predictionType: null,
            showNext: false,
          }));
        }
        navigate("/prediction");
        break;
      case 3:
        console.log("3");

        if (
          prediction.electionTypeData?.type !== null &&
          prediction.electionTypeData?.id !== null
        ) {
          setPrediction((prev) => ({
            ...prev,
            predictionType: null,
            predictionTitle: null,
          }));
          navigate("/prediction");
        }
        break;
      default:
        break;
    }
  };

  return (
    <div className="flex flex-col md:flex-row justify-between items-center w-full mb-4 px-2 md:px-4">
      {steps.map((step, index) => {
        const isActive = index <= currentStep;
        const isCurrent = index === currentStep;

        return (
          <div key={index} className="flex items-center w-full md:w-auto">
            <div
              onClick={() => onStepClick(index)}
              className={`min-w-[100px] md:min-w-[20px] flex flex-col items-center cursor-pointer group`}
              title={`Go to: ${step}`}
            >
              <div
                className={`flex items-center justify-center w-8 h-8 rounded-full text-xs font-bold transition-all duration-300 ${
                  isActive
                    ? "bg-[#012169] text-white"
                    : "bg-gray-300 text-gray-600"
                } group-hover:scale-105`}
              >
                {index + 1}
              </div>
              <div
                className={`text-[10px] md:text-xs mt-1 text-center max-w-[160px] ${
                  isCurrent ? "text-[#012169] font-medium" : "text-gray-600"
                }`}
              >
                {step}
              </div>
            </div>
            {index !== steps.length - 1 && (
              <div className="hidden md:block h-1 bg-gray-300 mx-2  flex-1 rounded-full" />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default PredictionStepper;
